/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_SubtitleInputs */

const en_visa_eb1_subtitle = /** @type {(inputs: Visa_Eb1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORITY WORKERS`)
};

const pt_visa_eb1_subtitle = /** @type {(inputs: Visa_Eb1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRABALHADORES PRIORITÁRIOS`)
};

const es_visa_eb1_subtitle = /** @type {(inputs: Visa_Eb1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRABAJADORES PRIORITARIOS`)
};

/**
* | output |
* | --- |
* | "PRIORITY WORKERS" |
*
* @param {Visa_Eb1_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_subtitle = /** @type {((inputs?: Visa_Eb1_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_subtitle(inputs)
	if (locale === "es") return es_visa_eb1_subtitle(inputs)
	return en_visa_eb1_subtitle(inputs)
});